<button [popover]="confirmationPopover"
        class="{{className}}"
        placement="{{placement}}"
        popoverTitle="{{ 'general.confirm' | translate }}"
        containerClass="confirmation-popover"
        container="body"
        triggers="click"
        [outsideClick]="true"
        #pop="bs-popover"
        (click)="$event.preventDefault(); $event.stopPropagation();">
    {{label}}
</button>
<ng-template #confirmationPopover>
    <p>{{ question | translate }}</p>
    <span *ngIf="!!additionalInfo" [innerHTML]="additionalInfo"></span>
    <div class="popover-buttons">
        <primary-text-button (onClick)="onConfirmed.emit();"
                             [noLeftPadding]="true"
        >
            {{'confirm.yes' | translate }}
        </primary-text-button>
        <cancelary-text-button (onClick)="pop.hide()">
            {{'confirm.no' | translate }}
        </cancelary-text-button>
    </div>
</ng-template>
